import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
interface Clientes{
  value: number;
  name: string;
}
@Component({
  selector: 'app-agregar-cliente',
  templateUrl: './agregar-cliente.component.html',
  styleUrls: ['./agregar-cliente.component.css']
})
export class AgregarClienteComponent {

  estado: string = "1";
  telefonoError: boolean = false;
  razonSocialError: boolean = false;
  nombreComercialError: boolean = false;
  clienteCreado: boolean = false;
  errorMessage: string = "";
  errorFinal: boolean = false;
  nifError: boolean = false;
  waitAfterSave: boolean = false;

  signin: FormGroup = new FormGroup({
    razonSocial: new FormControl('', [Validators.required]),
    nombreComercial: new FormControl('', [Validators.required]),
    iniciales: new FormControl(''),
    nif: new FormControl(''),
    telefono: new FormControl(''),
    personaContacto: new FormControl('')
  });

  private agregarClienteSubscription: Subscription | undefined;

  constructor(private userService : UserService){}

  ngOnDestroy(): void {
    if (this.agregarClienteSubscription) {
      this.agregarClienteSubscription.unsubscribe();
    } 
  }

  get razonSocialInput() { 
    return this.signin.get('razonSocial'); 
  }
  get nombreComercialInput() { 
    return this.signin.get('nombreComercial'); 
  }
  get inicialesInput() { 
    return this.signin.get('iniciales'); 
  }
  get nifInput() { 
    return this.signin.get('nif'); 
  }
  get telefonoInput() { 
    return this.signin.get('telefono'); 
  }
  get personaContactoInput() { 
    return this.signin.get('personaContacto'); 
  }

  clearField(fieldName: string) {
    this.signin.get(fieldName)?.setValue('');
  }

  get isPhoneNumberValid(): boolean {
    const phoneControl = this.telefonoInput;
    const phoneNumber = phoneControl?.value;
    // Si el número de teléfono está vacío, considerarlo válido
    if (!phoneNumber || phoneNumber.trim() === '') {
      return true;
    }
    const mask = '000 00 00 00'; // Formato utilizado en ngx-mask
    const requiredLength = mask.replace(/[^0]/g, '').length;
    
    return phoneNumber.replace(/[^0-9]/g, '').length === requiredLength;
  }

  validateDNI(dni:any) {
    var numero, x, letra;
    var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;
    dni = dni.toUpperCase();
    if (dni.length == 0) {
      return true;
    }
    if(expresion_regular_dni.test(dni) === true){
        numero = dni.substr(0,dni.length-1);
        numero = numero.replace('X', 0);
        numero = numero.replace('Y', 1);
        numero = numero.replace('Z', 2);
        x = dni.substr(dni.length-1, 1);
        numero = numero % 23;
        letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
        letra = letra.substring(numero, numero+1);
        if (letra != x) {
            //alert('Dni erroneo, la letra del NIF no se corresponde');
            return false;
        }else{
            //alert('Dni correcto');
            return true;
        }
    }else{
        //alert('Dni erroneo, formato no válido');
        return false;
    }
  }

  guardarCliente(){
    //Error razonSocial vacio
    if(this.razonSocialInput?.value == ""){
      this.razonSocialError = true;
    } else{
      this.razonSocialError = false;
    }
    //Error nombre comercial vacio
    if(this.nombreComercialInput?.value == ""){
      this.nombreComercialError = true;
    } else{
      this.nombreComercialError = false;
    }
    //Error nif
    if (this.validateDNI(this.nifInput?.value)){
      this.nifError=false;
    } else{
      this.nifError=true;
    }
    //Error teléfono invalido o vacio
    if(this.isPhoneNumberValid){
      this.telefonoError = false;
    } else {
      this.telefonoError = true;
    }
    //Si no hay errores el cliente se crea correctamente
    if(this.razonSocialError == false && this.nombreComercialError == false && this.telefonoError == false && this.nifError == false){
      let client = { _method: "PUT", razon_social: this.razonSocialInput?.value, nombre_comercial: this.nombreComercialInput?.value, iniciales: this.inicialesInput?.value,
      nif: this.nifInput?.value, contacto: this.personaContactoInput?.value, telefono: this.telefonoInput?.value, status: this.estado};
      this.agregarClienteSubscription = this.userService.createClient(client).subscribe({
        next:resp => {
        }, error: err =>{
          this.errorMessage = err.error.message;
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.errorFinal = true;
            setTimeout(() => {
              this.errorFinal = false;
              this.waitAfterSave = false;
            },3500)
          }
        }, complete: () =>{
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.clienteCreado=true;
            setTimeout(() => {
              //Vaciar los valores de los inputs para que 
              this.signin.setValue({
                razonSocial: '',
                nombreComercial: '',
                iniciales: '',
                nif: '',
                telefono: '',
                personaContacto: '',
              });
              this.estado = "1";
              this.waitAfterSave = false;
              this.clienteCreado = false;
            }, 3500);
          }
        }
      })
    }
    
    /*console.log("Razoón social: ", this.razonSocialInput?.value);
    console.log("Nombre comercial: ", this.nombreComercialInput?.value);
    console.log("Iniciales: ", this.inicialesInput?.value);
    console.log("NIF: ", this.nifInput?.value);
    console.log("Teléfono: ", this.telefonoInput?.value);
    console.log("Persona de Contacto: ", this.personaContactoInput?.value);
    console.log("Estado: ", this.estado);

    console.log('---------------------------------------');*/
  }

}
